import React, { Component } from "react"
import ReactPlayer from "react-player"
import YouTube from "react-youtube"

class VideoPlayer extends Component {
    render() {
        var url = this.props.url
        var width = this.props.width
        var height = this.props.height
        if (url !== null && (url.includes("youtube.com") || url.includes("youtu.be"))) {
            const videoURL = url.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/)
            const videoID = videoURL[2] !== undefined ? videoURL[2] : url[2]
            const options = {
                height: height,
                width: width,
                playerVars: {
                    autoplay: 0
                }
            }
            return <YouTube
                id="YTVideo"
                videoId={videoID}
                containerClassName="yt-video-wrapper"
                opts={options}
                // onPlay={() => onMediaAction(activeTopic, 1)}
                // onPause={() => onMediaAction(activeTopic, 2)}
                // onEnd={() => onMediaAction(activeTopic, 3)}
                // onError={() => onMediaAction(activeTopic, 4)}
            />
        } else {
            return (
                <ReactPlayer
                    style={{ background: "black" }}
                    preload="none"
                    id="video"
                    // poster={thumbnail}
                    ref="video"
                    height= {height}
                    width= {width}
                    url={url}
                    controls={true}
                    // onEnded={() => onMediaAction(topicList, 3)}
                    // onError={() => onMediaAction(topicList, 4)}
                    // onPause={() => onMediaAction(topicList, 2)}
                    // onPlay={() => onMediaAction(topicList, 1)}
                />
            )
        }
    }
}

export default VideoPlayer


// WEBPACK FOOTER //
// ./src/components/Public/Home/VideoPlayer.js